/* afich PDP — sélection Cadre/Format, prix par format, galerie, barre collante, roue promo. */
(function () {
  'use strict';

  function money(cents) {
    var v = cents / 100;
    var s = v % 1 === 0 ? String(v) : v.toFixed(2).replace('.', ',');
    return s + ' €';
  }
  function frameKind(value) {
    var v = String(value || '').toLowerCase();
    if (v.indexOf('bois') >= 0) return 'bois';
    if (v.indexOf('blanc') >= 0) return 'blanc';
    if (v.indexOf('noir') >= 0) return 'noir';
    return 'none';
  }

  function init(root) {
    if (root._afpdp) return;
    root._afpdp = true;
    var dataEl = root.querySelector('[data-afpdp-product]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var framePos = +root.dataset.framePos || 0;
    var formatPos = +root.dataset.formatPos || 0;
    var fields = [].slice.call(root.querySelectorAll('.afpdp-field'));
    var idInput = root.querySelector('form input[name=id]');
    var cta = root.querySelector('[data-afpdp-cta]');
    var ctaLabel = root.querySelector('[data-afpdp-cta-label]');
    var stage = root.querySelector('[data-afpdp-stage]');
    var slides = [].slice.call(root.querySelectorAll('.afpdp-slide'));
    var thumbs = [].slice.call(root.querySelectorAll('.afpdp-thumb'));
    var bars = [].slice.call(root.querySelectorAll('.afpdp-bars span'));
    var caption = root.querySelector('[data-afpdp-caption]');
    var mobile = window.matchMedia('(max-width: 989px)');

    /* ---------- Tri des formats par taille ---------- */
    fields.forEach(function (f) {
      if (f.dataset.kind !== 'rows') return;
      var wrap = f.querySelector('.afpdp-rows');
      var rows = [].slice.call(wrap.children);
      if (rows.every(function (r) { return +r.dataset.sizeNum > 0; })) {
        rows.sort(function (a, b) { return +a.dataset.sizeNum - +b.dataset.sizeNum; })
          .forEach(function (r) { wrap.appendChild(r); });
      }
    });
    /* Ordre des cadres : sans, bois, blanc, noir */
    var frameWrap = root.querySelector('.afpdp-frames');
    if (frameWrap) {
      var order = { none: 0, bois: 1, blanc: 2, noir: 3 };
      [].slice.call(frameWrap.children)
        .sort(function (a, b) { return order[a.dataset.frameKind] - order[b.dataset.frameKind]; })
        .forEach(function (el) { frameWrap.appendChild(el); });
    }

    function selected() {
      return fields.map(function (f) {
        var c = f.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function posIndex(pos) {
      for (var i = 0; i < fields.length; i++) if (+fields[i].dataset.optionPos === pos) return i;
      return -1;
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    /* ---------- Galerie ---------- */
    var current = 0;
    function show(index, opts) {
      opts = opts || {};
      if (index < 0 || index >= slides.length) return;
      current = index;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      revealThumb(index);
      bars.forEach(function (b, i) { b.classList.toggle('is-active', i === index); });
      if (mobile.matches && stage && !opts.fromScroll) {
        stage.scrollTo({ left: index * stage.clientWidth, behavior: opts.instant ? 'auto' : 'smooth' });
      }
      updateCaption();
    }
    function updateCaption() {
      if (!caption) return;
      var slide = slides[current];
      var label = '';
      if (slide && slide.classList.contains('afpdp-slide--poster')) label = data.captions.none;
      else {
        var img = slide && slide.querySelector('img');
        var src = img ? (img.getAttribute('src') || '') : '';
        if (/_wood/.test(src)) label = data.captions.bois;
        else if (/_white/.test(src)) label = data.captions.blanc;
        else if (/_black/.test(src)) label = data.captions.noir;
      }
      caption.textContent = 'Vue ' + (current + 1) + ' / ' + slides.length + (label ? ' — ' + label : '');
    }
    function indexOfMedia(id) {
      for (var i = 0; i < slides.length; i++) if (+slides[i].dataset.mediaId === id) return i;
      return -1;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

    /* ---------- Vignettes sur une ligne : flèches si elles débordent ---------- */
    var thumbRow = root.querySelector('.afpdp-thumbs');
    var thumbPrev = null, thumbNext = null;
    function thumbStep() { return thumbs[0] ? thumbs[0].getBoundingClientRect().width + 14 : thumbRow.clientWidth; }
    function updateThumbNav() {
      if (!thumbRow || !thumbPrev) return;
      var over = thumbRow.scrollWidth - thumbRow.clientWidth > 2;
      thumbPrev.hidden = thumbNext.hidden = !over;
      thumbPrev.disabled = thumbRow.scrollLeft <= 2;
      thumbNext.disabled = thumbRow.scrollLeft >= thumbRow.scrollWidth - thumbRow.clientWidth - 2;
    }
    function revealThumb(i) {
      var t = thumbs[i];
      if (!thumbRow || !t) return;
      var left = t.offsetLeft - thumbRow.offsetLeft, right = left + t.offsetWidth;
      if (left < thumbRow.scrollLeft) thumbRow.scrollTo({ left: left - 5 });
      else if (right > thumbRow.scrollLeft + thumbRow.clientWidth) thumbRow.scrollTo({ left: right - thumbRow.clientWidth + 5 });
    }
    if (thumbRow) {
      var wrap = document.createElement('div');
      wrap.className = 'afpdp-thumbs-wrap';
      thumbRow.parentNode.insertBefore(wrap, thumbRow);
      wrap.appendChild(thumbRow);
      var arrow = function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'afpdp-thumbs-nav afpdp-thumbs-nav--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Vignettes précédentes' : 'Vignettes suivantes');
        b.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir === 'prev' ? 'm15 18-6-6 6-6' : 'm9 18 6-6-6-6') + '"/></svg>';
        b.addEventListener('click', function () { thumbRow.scrollBy({ left: (dir === 'prev' ? -1 : 1) * thumbStep() }); });
        wrap.appendChild(b);
        return b;
      };
      thumbPrev = arrow('prev');
      thumbNext = arrow('next');
      thumbRow.addEventListener('scroll', updateThumbNav, { passive: true });
      window.addEventListener('resize', updateThumbNav);
      window.addEventListener('load', updateThumbNav);
      updateThumbNav();
    }
    var prevBtn = root.querySelector('[data-afpdp-prev]'), nextBtn = root.querySelector('[data-afpdp-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { show((current - 1 + slides.length) % slides.length); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show((current + 1) % slides.length); });
    if (stage) stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show((current - 1 + slides.length) % slides.length); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show((current + 1) % slides.length); }
    });
    if (stage) {
      var st;
      stage.addEventListener('scroll', function () {
        if (!mobile.matches) return;
        clearTimeout(st);
        st = setTimeout(function () {
          var i = Math.round(stage.scrollLeft / stage.clientWidth);
          if (i !== current) show(i, { fromScroll: true });
        }, 80);
      }, { passive: true });
    }

    /* ---------- Teinte de fond déduite de l'affiche ---------- */
    (function tint() {
      var img = slides[0] && slides[0].querySelector('img');
      if (!img || root.style.getPropertyValue('--afpdp-poster')) return;
      function run() {
        try {
          var c = document.createElement('canvas'); c.width = 24; c.height = 36;
          var x = c.getContext('2d'); x.drawImage(img, 0, 0, 24, 36);
          var d = x.getImageData(0, 0, 24, 36).data, r = 0, g = 0, b = 0, n = 0;
          for (var i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
          r = Math.round(r / n); g = Math.round(g / n); b = Math.round(b / n);
          var mix = function (v, k) { return Math.round(v + (255 - v) * k); };
          root.style.setProperty('--afpdp-poster', 'rgb(' + r + ',' + g + ',' + b + ')');
          if (!root.hasAttribute('data-tint-fixed')) {
            root.style.setProperty('--afpdp-tint', 'rgb(' + mix(r, .74) + ',' + mix(g, .74) + ',' + mix(b, .74) + ')');
          }
        } catch (e) { /* image cross-origin : on garde le repli */ }
      }
      if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
    })();

    /* ---------- Prix et disponibilité par format ---------- */
    function refreshRows(sel) {
      fields.forEach(function (f, fi) {
        if (f.dataset.kind !== 'rows') return;
        [].forEach.call(f.querySelectorAll('.afpdp-row'), function (row) {
          var input = row.querySelector('input');
          var opts = sel.slice(); opts[fi] = input.value;
          var v = findVariant(opts);
          var price = row.querySelector('[data-afpdp-row-price]');
          var off = !v || !v.available;
          row.classList.toggle('is-disabled', off);
          input.disabled = off;
          if (price) {
            if (v && v.available) price.textContent = money(v.price);
            else if (!v && framePos && frameKind(opts[posIndex(framePos)]) !== 'none') price.textContent = 'sans cadre uniquement';
            else price.textContent = 'épuisé';
          }
        });
      });
    }

    function update(changedField) {
      var sel = selected();
      var v = findVariant(sel);
      /* Combinaison inexistante (ex. 59×84 encadré) : on bascule l'autre option sur la plus proche disponible. */
      if (!v || !v.available) {
        var other = fields.filter(function (f) { return f !== changedField && f.dataset.kind === 'rows'; })[0] ||
                    fields.filter(function (f) { return f !== changedField; })[0];
        if (other) {
          var oi = fields.indexOf(other);
          var inputs = [].slice.call(other.querySelectorAll('input')).reverse();
          for (var k = 0; k < inputs.length; k++) {
            var opts = sel.slice(); opts[oi] = inputs[k].value;
            var cand = findVariant(opts);
            if (cand && cand.available) { inputs[k].checked = true; sel = opts; v = cand; break; }
          }
        }
      }
      refreshRows(sel);
      fields.forEach(function (f) {
        var cur = f.querySelector('[data-afpdp-current]');
        var c = f.querySelector('input:checked');
        if (cur && c) cur.textContent = c.value;
      });
      if (!v) {
        if (ctaLabel) ctaLabel.textContent = 'Indisponible';
        if (cta) cta.disabled = true;
        return;
      }
      if (idInput) { idInput.value = v.id; idInput.disabled = !v.available; }
      if (cta) cta.disabled = !v.available;
      if (ctaLabel) ctaLabel.textContent = v.available ? 'Ajouter au panier — ' + money(v.price) : 'Épuisé';
      var sl = root.querySelector('[data-afpdp-sticky-label]'); if (sl) sl.textContent = v.available ? 'Ajouter au panier — ' + money(v.price) : 'Épuisé';
      var sv = root.querySelector('[data-afpdp-sticky-variant]');
      var sp = root.querySelector('[data-afpdp-sticky-price]');
      if (sv) sv.textContent = v.title;
      if (sp) sp.textContent = money(v.price);
      if (v.media) { var mi = indexOfMedia(v.media); if (mi >= 0) show(mi); }
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u.href);
      } catch (e) {}
      if (idInput) idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    fields.forEach(function (f) {
      f.addEventListener('change', function (e) {
        if (e.target && e.target.name && e.target.name.indexOf('afpdp-option') === 0) update(f);
      });
    });

    /* Etat initial */
    refreshRows(selected());
    (function () {
      var v0 = idInput && variants.filter(function (x) { return String(x.id) === idInput.value; })[0];
      if (!v0) return;
      if (ctaLabel && v0.available) ctaLabel.textContent = 'Ajouter au panier — ' + money(v0.price);
      var sp0 = root.querySelector('[data-afpdp-sticky-price]'); if (sp0) sp0.textContent = money(v0.price);
      var sl0 = root.querySelector('[data-afpdp-sticky-label]'); if (sl0 && v0.available) sl0.textContent = 'Ajouter au panier — ' + money(v0.price);
    })();
    var initIdx = 0;
    slides.forEach(function (s, i) { if (s.classList.contains('is-active')) initIdx = i; });
    show(initIdx, { instant: true });

    /* ---------- Description « Lire plus » ---------- */
    var desc = root.querySelector('[data-afpdp-desc]');
    if (desc) {
      var more = desc.querySelector('[data-afpdp-more]');
      var txt = desc.querySelector('.afpdp-desc__text');
      requestAnimationFrame(function () {
        if (txt.scrollHeight > txt.clientHeight + 2) more.hidden = false;
      });
      more.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        more.textContent = open ? 'Lire moins' : 'Lire plus';
      });
    }

    /* ---------- Bandeau de la roue cadeaux (#af-october-banner) : après le CTA et la réassurance ---------- */
    var reassure = root.querySelector('.afpdp-reassure');
    function placeBanner() {
      var b = document.getElementById('af-october-banner');
      if (b && reassure && reassure.nextElementSibling !== b) reassure.insertAdjacentElement('afterend', b);
    }
    placeBanner();
    document.addEventListener('DOMContentLoaded', placeBanner);
    window.addEventListener('load', placeBanner);

    /* ---------- Barre collante mobile ---------- */
    var sticky = root.querySelector('[data-afpdp-sticky]');
    if (sticky && cta) {
      var stickyFrame = 0;
      function setSticky(show) {
        if (sticky.classList.contains('is-visible') === show) return;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelector('button').tabIndex = show ? 0 : -1;
      }
      // Visible tant que le bouton « Ajouter au panier » de la page n'est pas à l'écran (au-dessus ou en dessous),
      // masquée quand une fenêtre (panier, menu, atelier, roue…) est ouverte — comme la barre de la prod.
      function blocked() { return !!document.querySelector('#afp2-ov, cart-drawer.active, cart-notification.active, dialog[open], .menu-drawer-container[open], html.afmm-open'); }
      function checkSticky() {
        stickyFrame = 0;
        var r = cta.getBoundingClientRect();
        var onScreen = r.height > 0 && r.bottom > 0 && r.top < window.innerHeight - (sticky.classList.contains('is-visible') ? sticky.offsetHeight : 0);
        var show = !onScreen && !blocked();
        setSticky(show);
        document.documentElement.classList.toggle('afpdp-sticky-on', show);
      }
      window.addEventListener('scroll', checkSticky, { passive: true });
      window.addEventListener('resize', checkSticky);
      window.addEventListener('load', checkSticky);
      document.addEventListener('click', function () { setTimeout(checkSticky, 300); }, true);
      new MutationObserver(function () { if (!stickyFrame) stickyFrame = setTimeout(checkSticky, 150); })
        .observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open', 'class'] });
      checkSticky();
      sticky.querySelector('[data-afpdp-sticky-cta]').addEventListener('click', function () {
        if (cta.disabled) { cta.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        cta.click();
      });
    }
  }

  function boot() { [].forEach.call(document.querySelectorAll('.afpdp'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
